import { useEffect, useRef, useState } from "react";
const { createObjectURL, revokeObjectURL } = URL;
export function useWorker(onWorkerMessage, onWorkerError) {
    const workerJs = useRef(null);
    const workerRef = useRef(null);
    const blobUrl = useRef(null);
    const setWorker = useState(null)[1];
    const [error, setError] = useState(null);
    const reInitWorker = (memory) => {
        if (workerRef.current)
            workerRef.current.terminate();
        if (blobUrl.current)
            revokeObjectURL(blobUrl.current);
        const newWorker = new Worker(blobUrl.current = createObjectURL(new Blob([workerJs.current], { type: "text/javascript" })));
        newWorker.onmessage = (e => { if (onWorkerMessage.current)
            onWorkerMessage.current(e); });
        newWorker.onerror = (e => { if (onWorkerError.current)
            onWorkerError.current(e); });
        if (memory)
            newWorker.postMessage({
                type: "setMem" /* RequestType.SET_MEMORY */,
                uid: -1,
                expr: memory[0],
                angleUnit: memory[1],
                numeralBase: memory[2],
            });
        setWorker(workerRef.current = newWorker);
        return newWorker;
    };
    useEffect(() => {
        async function loadWorker() {
            const workerCode = "```&INLINED_WORKER_CODE&```";
            if (workerCode.charCodeAt(0) !== "`".charCodeAt(0)) {
                try {
                    workerJs.current = workerCode;
                    reInitWorker();
                }
                catch (e) {
                    setError(e.message);
                }
            }
            else {
                try {
                    const response = await fetch("cpp_worker.js");
                    if (response.ok) {
                        const workerCode = await response.text();
                        workerJs.current = workerCode;
                        reInitWorker();
                    }
                    else {
                        throw "fetch status=" + response.status;
                    }
                }
                catch (e) {
                    setError(e.message);
                }
            }
        }
        loadWorker();
        return () => {
            if (workerRef.current)
                workerRef.current.terminate();
        };
    }, []);
    return [
        workerRef,
        error,
        reInitWorker,
        setError,
    ];
}
